module.exports = require('./lib/layout')


/** WEBPACK FOOTER **
 ** ../biro-material-ui/layout.js
 **/